import axios from 'axios';
const api = axios.create({
  baseURL: 'https://master.filadelfiablessingfamily.org/api', 
});

export { api };
